module.exports = {"id":"212218","name":"Aymeric Laporte","rating":"83","photo":"./data/images/photos/0/212218.png","club":{"name":"Manchester City","logo":"./data/images/clubs/ManchesterCity.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AymericLaporte0.json
// module id = 507
// module chunks = 0